module.exports = __webpack_public_path__ + "img/3.fb264aaa.svg";